<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>

        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div>{{ answer[JsonFieldToDisplay()] | displayArrayAsString }}</div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span class="skipped-question-box ml-15 d-inline-box pt-2" v-if="isQuestionSkipped()">Skipped </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div v-if="question.subType === 'Single'">
            <b-form-group>
              <b-form-radio-group stacked :name="`multiChoice${question.id}`" v-model="updatedAns[0]" v-validate="'required'" :disabled="answer && answer.isDisabled"  v-on:change="onChangeMultiOptions($event, question.subType)">
                <b-form-radio v-for="option in question.options" :key="option.id" :value="option.id">
                  {{ option.body }}
                </b-form-radio>
              </b-form-radio-group>

              <span class="text-warning pl-15 fw-bold" v-if="hasFieldWarning">{{ fieldWarningText }} </span>
              <span class="text-danger pl-15 fw-bold" v-if="hasFieldError">{{ fieldErrorText }} </span>
            </b-form-group>
          </div>
          <div v-else-if="question.subType === 'Multi'">
            <b-form-group>
              <b-form-checkbox-group stacked :name="`multiChoice${question.id}`" v-model="updatedAns" v-validate="'required'" :disabled="answer && answer.isDisabled" v-on:change="onChangeMultiOptions($event, question.subType)">
                <b-form-checkbox v-for="option in question.options" :key="option.id" :value="option.id">
                  {{ option.body }}
                </b-form-checkbox>
              </b-form-checkbox-group>
              <span class="text-danger pl-15 fw-bold" v-if="hasFieldError">{{ fieldErrorText }} </span>
            </b-form-group>
          </div>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.answer_text : answer.display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>

            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.privius_answer_text : answer.privius_display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.privius_score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "MultiChoiceResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: [],
      hasFieldError:false,
      fieldErrorText:"",
      fieldWarningText:"",
      scoresMap: {},
      hasFieldWarning:"",
      noneOptionId: '',
      disableCheckBox: false
    };
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    surveyData: Object,
    usage: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    activityType: String
  },
  filters: {
    displayArrayAsString(array) {
      if (typeof array === "string") {
        return array;
      }

      if (array instanceof Array) {
        return array.join(`, `);
      }
    }
  },
  watch: {
    updatedAns() {
      this.checkForFieldErrors();
      if (this.hasFieldError) {
        this.resetFields();
      } else {
        if (this.question.options) {
          const selectedOption = this.question.options.filter(opt => opt.id == this.updatedAns[0])[0];
          if (this.answer && selectedOption) {
            if (this.question.subType == "Single") {
              this.answer.optionId = selectedOption.id;
              this.answer.answerText = selectedOption.body;
              if (this.answer.optionId == this.question.otherOptionId && this.question.otherCommentSelectedField && this.mode == 1) {
                this.$toastr.success(this.question.otherCommentSelectedField);
              }
            } else {
              this.answer.optionId = this.updatedAns.join();
              const multipleOptions = this.findAnsweredSequence().map(i => i.body);
              const arrMultiOptions = this.answer.optionId.split(",");

              if (arrMultiOptions.includes(this.question.otherOptionId) && this.question.otherCommentSelectedField && this.mode == 1) {
                this.$toastr.success(this.question.otherCommentSelectedField);
              }
              this.answer.answerText = multipleOptions.join();
            }
          }
        }
      }
    },
    hasFieldError(val) {
      this.question.hasFieldError = val;
    }
  },
  mounted() {
   if(this.answer) {
      if(this.mode == 2 && this.answer.option_id) {
        if (this.question.subType == "Single") {
          this.updatedAns[0] = this.answer.option_id;
        } else {
          this.updatedAns = this.answer.option_id.split(",");
        }
      } else if (this.answer.optionId) {
        this.insertOtherOption();
        if (this.question.subType == "Single") {
          this.updatedAns[0] = this.answer.optionId;
        } else {
          this.updatedAns = this.answer.optionId.split(",");
        }
      }
    }
    this.calculateScoresMap();
  },
  methods: {
    resetFields() {
      this.answer.optionId = "";
      this.answer.answerText = "";
      this.answer.score = 0;
      this.answer.computedScore = 0;
    },
    onChangeMultiOptions(optionIds, questionType) {
      if (questionType === 'Multi') {
        let noneOption = _.find(this.question.options, function (o) { return (o.formattedBody.toLowerCase() == 'none') })
        if (noneOption) {
          this.noneOptionId = noneOption.id;
        }
        this.disableCheckBox = false
        if (optionIds && optionIds.includes(this.noneOptionId)) {
          this.answer.optionsIds = [];
          this.answer.optionsIds.push(this.noneOptionId)
          this.updatedAns = []
          this.updatedAns.push(this.noneOptionId);
          this.disableCheckBox = true
        }
        if (optionIds instanceof Array) {
          this.answer.score = 0;
          optionIds.forEach((id) => {
            for (let score in this.scoresMap) {
              if (score === id) {
                this.answer.score += this.scoresMap[score];
              }
            }
          })
        }
      }
      else {
        this.answer.score = this.scoresMap[optionIds];
      }
      this.$forceUpdate();
      this.answerUpdated();
    },
    calculateScoresMap() {
      if (this.question.options) {
        this.question.options.forEach((option) => {
          this.scoresMap[option.id] = option.score || 0;
        });
      }
    },
    answerUpdated() {
      this.$nextTick(() => {
        this.$emit(`answerChanged`, {
          questionId: this.question.id,
          newAns: this.updatedAns
        });
      });
    },
    findAnsweredSequence() {
      return this.updatedAns.map(item => {
        return this.question.options.filter(opt => opt.id == item)[0];
      });
    },
    checkForFieldErrors() {
      this.reseterror();
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns.length == 0) {
              this.question.isSkippable = true;
              this.$validator.validateAll().then(result => {
                if (!result) {
                  this.hasFieldWarning = true;
                  this.fieldWarningText = "This field is required.";
                  this.hasFieldError = true;
                  softDataCheck = true;
                  this.fieldErrorText = "This field is required.";
                }
              });
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: `This field is required.`
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns.length == 0) {
              this.question.isSkippable = false;
              this.$validator.validateAll().then(result => {
                if (!result) {
                  this.hasFieldError = true;
                  this.fieldErrorText = "This field is required.";
                }
              });
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      } else {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.hasFieldError = true;
            this.fieldErrorText = "This field is required.";
          }
        });
      }
    },
    reseterror() {
      this.hasFieldError = false;
      this.hasFieldWarning = false;
    },
    insertOtherOption() {
      if (this.question.otherOptionId) {
        const sequence = this.question.options.length + 1;
        this.question.options.push({
          body: this.question.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: null
          },
          enabled: true,
          excludeScore: false,
          formattedBody: this.question.otherOptionContentField,
          id: this.question.otherOptionId,
          isAdvancedScoring: false,
          priority: 0,
          sendNotification: false,
          sequence: sequence,
          score: this.question.otherScore
        });
      }
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>
